// AI 직군별 분석 사이드 팝업으로 이동해주는 배너입니다.

import { QIcon_search_bold } from '@repo/icons/index'
import { useState } from 'react'
import { useEventTracking } from '../../../helpers/gtmHelper'
import { APP_SCREEN_NAME } from '../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useIsMobile from '../../../modules/hooks/common/useIsMobile'
import useIsWebview from '../../../modules/hooks/common/useIsWebview'
import useReturnFullUrl from '../../../modules/hooks/webview/common/useReturnFullUrl'
import { n_ai_analysis } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import urls from '../../../modules/urls'
import { COLORS } from '../../../modules/vars'
import useCafJobAnalysisSidePopup from '../../new-portal/caf/CAFOverview/popup/useCafJobAnalysisSidePopup'
import useJobAnalysisPopup from '../../new-portal/caf/CAFOverview/popup/useJobAnalysisPopup'
import JobAnalysisModal from '../../new-portal/caf/common/JobAnalysis/JobAnalysisModal'
import MessageCard, { MESSAGE_CARD_SIZE } from '../MessageCard'

interface ICafJobAnalysisEncouragementBoxProps {
  page: 'review' | 'statistic' | 'myRingle'
  onClose?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

export const CafJobAnalysisEncouragementBox = ({ page, onClose = () => {} }: ICafJobAnalysisEncouragementBoxProps) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(true)
  const isMobile = useIsMobile()

  // TODO: naming 다시 하기
  const [showAlertPopup, setShowAlertPopup] = useState(false)
  const [showJobInputPopup, setShowJobInputPopup] = useState(false)
  const { isShowAlertPopup, isShowJobInputPopup, info, jobStatus } = useJobAnalysisPopup()
  const isWebview = useIsWebview()
  const router = useAppRouter()
  const { show, close } = useCafJobAnalysisSidePopup()
  const getFullUrl = useReturnFullUrl()
  const { sendClickEvent } = useEventTracking()

  const handleClickButton = () => {
    sendClickEvent({
      button_name: 'ai_analysis_job_segment_banner',
      object_title: jobStatus,
    })
    if (isShowJobInputPopup) {
      if (isWebview) {
        router.push(urls.webview.caf.analysis.jobInput, {
          appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
          appSendData: { url: getFullUrl(urls.webview.caf.analysis.jobInput) },
        })
      } else {
        setShowJobInputPopup(true)
      }
    } else if (isShowAlertPopup) {
      setShowAlertPopup(true)
    } else {
      if (isWebview) {
        router.push(urls.webview.caf.analysis.jobFilter, {
          appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
          appSendData: {
            url: getFullUrl(urls.webview.caf.analysis.jobFilter),
          },
        })
      } else {
        show()
      }
    }
  }

  if (!open) return <></>

  return (
    <div className="w-full relative">
      <div className={page === 'review' ? 'flex lg:hidden' : 'flex md:hidden'}>
        <MessageCard
          icon={<QIcon_search_bold color={COLORS.PURPLE400} width={24} height={24} />}
          size={MESSAGE_CARD_SIZE.SM}
          title={t(n_ai_analysis.banner_title)}
          description={t(n_ai_analysis.banner_detail)}
          zIndex={1}
          onClickClose={(e) => {
            e.preventDefault()
            e.stopPropagation()
            onClose && onClose(e)
            setOpen(false)
          }}
          buttonTitle={t(n_ai_analysis.banner_btn)}
          buttonColor={COLORS.PURPLE600}
          onClickButton={handleClickButton}
        />
      </div>
      <div className={page === 'review' ? 'hidden lg:flex' : 'hidden md:flex'}>
        <MessageCard
          icon={<QIcon_search_bold color={COLORS.PURPLE400} width={24} height={24} />}
          size={MESSAGE_CARD_SIZE.LG}
          title={t(n_ai_analysis.banner_title)}
          description={t(n_ai_analysis.banner_detail)}
          zIndex={1}
          onClickClose={(e) => {
            e.preventDefault()
            e.stopPropagation()
            onClose && onClose(e)
            setOpen(false)
          }}
          buttonTitle={t(n_ai_analysis.banner_btn)}
          buttonColor={COLORS.PURPLE600}
          onClickButton={handleClickButton}
        />
      </div>
      <JobAnalysisModal
        isShowAlertPopup={isShowAlertPopup}
        showAlertPopup={showAlertPopup}
        setShowAlertPopup={setShowAlertPopup}
        info={info}
        isShowJobInputPopup={isShowJobInputPopup}
        showJobInputPopup={showJobInputPopup}
        setShowJobInputPopup={setShowJobInputPopup}
      />
    </div>
  )
}

export default CafJobAnalysisEncouragementBox
